<template>
	<page enable-flex :create-button="auth('b_app_aftersale_order_edit')" @create="addHandle">
		<view-list work-type="2" view-id="10002" :search="{placeholder: '搜工单编号、产品'}">
			<!-- <template #filter>
				<m-search ref="search">
					<m-search-item label="创建时间">
						<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
					</m-search-item>
				</m-search>
			</template> -->

			<template #default="{data, index}">
				<view-list-card :key="index" :data="data" @click="mp.navigateWeb('/aftersales/work/detail', {id: data.id})">
					<template #base_state>
						<c-state dict="afterSaleOrderStateDic" tag :value="data.status"></c-state>
						<c-state dict="serviceTypeDic" tag :value="data.service_type"></c-state>
						<c-state v-if="data.urgency_level!=1" dict="orderUrgencyDic" tag :value="data.urgency_level"></c-state>
                        <c-state v-if="data.is_delayed == 1" tag color="red">
                            逾期<span v-if="data.delayed_days > 0">{{data.delayed_days}}天</span>
                        </c-state>
					</template>

					<!--工单状态-->
					<template #status>
						<c-state dict="afterSaleOrderStateDic" :value="data.status"></c-state>
					</template>
                    <!--处理单状态-->
                    <template #complaint_status>
                        <c-state dict="complaintConfirmStatusDic" :value="data.complaint_status"></c-state>
                    </template>

                    <!--紧急程度-->
					<template #urgency_level>
						<c-state dict="orderUrgencyDic" :value="data.urgency_level"></c-state>
					</template>

					<!--工单逾期-->
					<template #urgency_level>
						<c-state dict="isDelayedDic" :value="data.is_delayed"></c-state>
					</template>

					<!--出行方式-->
					<template #travel_mode>
						<c-state dict="travelModeDic" :value="data.travel_mode"></c-state>
					</template>

					<!--是否使用机台-->
					<template #use_machine>
						<c-state dict="useMachineDic" :value="data.use_machine"></c-state>
					</template>

					<!--预计上门人数-->
					<template #estimated_technician_count>
						{{data.estimated_technician_count}}人
					</template>

					<!--预计服务时长-->
					<template #estimated_service_days>
						{{data.estimated_service_days}}天
					</template>

					<!--预估总成本-->
					<template #estimated_cost_total>
						￥{{data.estimated_cost_total}}
					</template>

					<!--驾车耗时-->
					<template #customer_duration>
						{{data.customer_duration}}天
					</template>

					<!--客户距离-->
					<template #customer_distance>
						{{data.customer_distance}}公里
					</template>

					<!--服务类型-->
					<template #service_type>
						<c-state dict="serviceTypeDic" :value="data.service_type"></c-state>
					</template>

					<!--售后类型-->
					<template #aftersale_type>
						<c-state dict="afterSaleTypeDic" :value="data.aftersale_type"></c-state>
					</template>

					<!--评价状态-->
					<template #evaluate_state>
						<c-state dict="evaluateTypeDic" :value="data.evaluate_state"></c-state>
					</template>

					<!--现场图-->
					<template #scene_images>
                        <c-file-list :value="data.scene_images" size="mini"></c-file-list>
					</template>

					<!--负责人-->
					<template #charge_user_realname>
						{{data.charge_user_realname}}
						<member-icon v-if="data.charge_user_realname" class="person" circle :icon="data.charge_user_head_photo" :name="data.charge_user_realname" text></member-icon>
					</template>

					<template #bar>
						<div class="card-bar flex-center">
							<div class="card-bar-total flex-column">
								<p>产品件数</p>
								<strong>{{data.product_count}}件</strong>
							</div>
							<div class="card-bar-total flex-column">
								<p>预计服务时长</p>
								<strong>{{data.estimated_service_days}}天</strong>
							</div>
							<div class="flex-grow flex-end-center">
								<c-progress :rate="[data.completion_progress || 0, 1]" type="circle" size="0.92" color="#00A1E9">
									<template #text="{rate}">
										<span :style="{'color': 'var(--color-main)'}">{{rate.toFixed(0)}}%</span>
									</template>
								</c-progress>
							</div>
						</div>
					</template>

					<template #operate>
						<c-button @click="mp.navigateWeb('/aftersales/work/detail', {id: data.id})">查看详情</c-button>
					</template>
				</view-list-card>
			</template>
		</view-list>
	</page>
</template>

<script>
	export default {
		name: 'm_app_aftersale_order',
		
		data() {
			return {
			}
		},
		
		methods: {
			addHandle() {
				this.mp.navigateWeb('/aftersales/work/edit')
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.person {
		position: absolute;
		right: .26rem;
		top: 1.6rem;
	}
</style>